import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';

const MsalEventHandler = () => {
    const { instance } = useMsal();

    useEffect(() => {
        const callbackId = instance.addEventCallback((event) => {
            switch (event.eventType) {
                case EventType.LOGIN_SUCCESS:
                    if (event.payload.account) {
                        instance.setActiveAccount(event.payload.account);
                    }
                    break;
                case EventType.LOGIN_FAILURE:
                    console.error('Login failed:', event.error);
                    break;
                case EventType.ACQUIRE_TOKEN_SUCCESS:
                    // Token acquired successfully
                    break;
                case EventType.ACQUIRE_TOKEN_FAILURE:
                    console.error('Token acquisition failed:', event.error);
                    break;
                case EventType.SSO_SILENT_SUCCESS:
                    if (event.payload.account) {
                        instance.setActiveAccount(event.payload.account);
                    }
                    break;
                case EventType.SSO_SILENT_FAILURE:
                    console.error('SSO silent failure:', event.error);
                    break;
                default:
                    break;
            }
        });

        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        };
    }, [instance]);

    // Handle page load - check for existing authentication
    useEffect(() => {
        const handlePageLoad = async () => {
            try {
                // Handle redirect promise
                const response = await instance.handleRedirectPromise();
                if (response && response.account) {
                    instance.setActiveAccount(response.account);
                }

                // Set active account if not already set
                const accounts = instance.getAllAccounts();
                if (accounts.length > 0 && !instance.getActiveAccount()) {
                    instance.setActiveAccount(accounts[0]);
                }
            } catch (error) {
                console.error('Error handling redirect:', error);
            }
        };

        handlePageLoad();
    }, [instance]);

    return null; // This component doesn't render anything
};

export default MsalEventHandler; 